import { useApiQuery } from '@/api/main/query'
import { useIsMobile } from '@/shared/utils'
import { useParams } from 'react-router-dom'
import { withdrawsAPIMerchant, withdrawsAPITrader } from '../api'
import { WithdrawsModel } from '../model'
import { getWithdrawInfoBlocks } from '../ui/payout/banners/WithdrawInfoBlocks'
import { getStorageItem } from '@/shared/lib'
import { USER_ROLE_KEY } from '@/features/auth'
import { Roles } from '@/entities/roles'

export const useWithdrawData = () => {
  const { id } = useParams<{ id: string }>()
  const queryKey = ['withdraw', id]
  const isMobile = useIsMobile()
  const userRole = getStorageItem<Roles | null>(USER_ROLE_KEY, null)
  const isMerchant = userRole === Roles.Merchant

  const { data, error, isLoading } = useApiQuery<WithdrawsModel>(
    queryKey,
    isMerchant ? withdrawsAPIMerchant.item(id ?? '') : withdrawsAPITrader.item(id ?? '')
  )

  if (!data) return { data: null, error, isLoading }

  const rubAmount = data.amountTo
  const usdtAmount = isMerchant ? data.amountFrom : data.traderAmountFrom+data.factTraderCommissionTo
  const rubFactAmount = data.factAmountTo
  const usdtFactAmount = isMerchant ? data.amountFrom : data.traderAmountFrom+data.factTraderCommissionTo

  const { infoBlock1, infoBlock2, infoBlock3 } = getWithdrawInfoBlocks(data, isMobile)

  return {
    data,
    error,
    isLoading,
    rubAmount,
    usdtAmount,
    rubFactAmount,
    usdtFactAmount,
    infoBlock1,
    infoBlock2,
    infoBlock3,
  }
}
